import { useTranslation } from 'react-i18next';
import { MarketplaceDetail } from '@anytag/graphql';
import { Drawer } from '@anytag/shared-atoms';
import { DraftTemplateComponent } from './DraftTemplate';
import { DefaultTemplateComponent } from './DefaultTemplate';

export interface MarketplacePostFormProps {
  postId: number;
  onClose: () => void;
  isDraftPost?: boolean;
  isAffiliateCampaign?: boolean;
  marketplaceId: MarketplaceDetail['id'];
}

export const MarketplacePostForm = ({
  postId,
  onClose,
  isDraftPost,
  marketplaceId,
  isAffiliateCampaign
}: MarketplacePostFormProps) => {
  const { t } = useTranslation();

  return (
    <Drawer.Root
      className="w-118"
      onClose={onClose}
      title={t(isDraftPost ? 'Review draft post' : 'Post Detail')}
      onInteractOutside={onClose}
      open
    >
      {isDraftPost ? (
        <DraftTemplateComponent postId={postId} onClose={onClose} />
      ) : (
        <DefaultTemplateComponent
          postId={postId}
          onClose={onClose}
          marketplaceId={marketplaceId}
          isAffiliateCampaign={isAffiliateCampaign}
        />
      )}
    </Drawer.Root>
  );
};
